import { FindMemberInfoResponseDto } from '#types/member';
import { Item, Key, Value } from './styles';

interface MemberInfoListProps {
  memberInfo: FindMemberInfoResponseDto;
}

export const MemberInfoList = ({ memberInfo }: MemberInfoListProps) => {
  const { healthInfo, purposes, athleticExperience, jobName } = memberInfo;

  const infoList = [
    {
      view: '키 · 몸무게',
      value:
        healthInfo?.height && healthInfo?.weight
          ? [healthInfo.height, healthInfo.weight]
          : '없음'
    },
    {
      view: '운동경력',
      value: athleticExperience ?? '없음'
    },
    {
      view: 'PT 수강목적',
      value: purposes?.[0]?.name ?? '없음'
    },
    {
      view: '수면정보',
      value:
        healthInfo?.sleepingHourAvg && healthInfo?.qualityOfSleep
          ? [healthInfo.sleepingHourAvg, healthInfo.qualityOfSleep]
          : '없음'
    },
    {
      view: '직업',
      value: jobName ?? '없음'
    },
    {
      view: '병력',
      value: healthInfo?.diseases?.length > 0 ? healthInfo.diseases : '없음'
    },
    {
      view: '수술 이력',
      value:
        healthInfo?.surgeryParts?.length > 0 ? healthInfo.surgeryParts : '없음'
    },
    {
      view: '통증 (부위/정도)',
      value: healthInfo?.painParts?.length > 0 ? healthInfo.painParts : '없음'
    }
  ] as const;

  return (
    <div>
      {infoList.map(info => {
        return (
          <Item key={info.view}>
            <Key>{info.view}</Key>
            <Value>
              {info.view === '키 · 몸무게' && (
                <div>
                  {info.value === '없음' ? (
                    <div>없음</div>
                  ) : (
                    <div>
                      {info.value[0]}cm · {info.value[1]}kg
                    </div>
                  )}
                </div>
              )}
              {info.view === '운동경력' && (
                <div>
                  {info.value}
                  {info.value !== '없음' && '년'}
                </div>
              )}
              {info.view === 'PT 수강목적' && <div>{info.value}</div>}
              {info.view === '직업' && <div>{info.value}</div>}
              {info.view === '병력' && <DiseaseList diseases={info.value} />}
              {info.view === '수술 이력' && (
                <SugeryList surgeries={info.value} />
              )}

              {info.view === '수면정보' && (
                <div className="flex flex-col gap-4">
                  {info.value === '없음' ? (
                    <div>없음</div>
                  ) : (
                    <>
                      <div>수면의 질: {info.value[0]}</div>
                      <div>수면시간: {info.value[1]}시간</div>
                    </>
                  )}
                </div>
              )}
              {info.view === '통증 (부위/정도)' && (
                <PainPartList painParts={info.value} />
              )}
            </Value>
          </Item>
        );
      })}
    </div>
  );
};

const PainPartList = ({
  painParts
}: {
  painParts: FindMemberInfoResponseDto['healthInfo']['painParts'] | string;
}) => {
  if (typeof painParts === 'string') return <>없음</>;

  return (
    <div>
      {painParts.map((painPart, index) => {
        return (
          <div key={index} className="flex gap-4">
            <PainPartNumber index={index} />
            <div>
              {painPart.kind.name} / {painPart.level}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const DiseaseList = ({
  diseases
}: {
  diseases: FindMemberInfoResponseDto['healthInfo']['diseases'] | string;
}) => {
  if (typeof diseases === 'string') return <>없음</>;

  return (
    <div>
      {diseases.map((disease, index) => {
        return (
          <div key={index} className="flex gap-4">
            <div>{disease.kind.name}</div>
          </div>
        );
      })}
    </div>
  );
};

const SugeryList = ({
  surgeries
}: {
  surgeries: FindMemberInfoResponseDto['healthInfo']['surgeryParts'] | string;
}) => {
  if (typeof surgeries === 'string') return <>없음</>;

  return (
    <div>
      {surgeries.map((surgery, index) => {
        return (
          <div key={index} className="flex gap-4">
            <div>{surgery.surgeryPartKind.name}</div>
          </div>
        );
      })}
    </div>
  );
};

const PainPartNumber = ({ index }: { index: number }) => {
  return (
    <div
      style={{
        display: 'flex',
        width: '20px',
        height: '20px',
        padding: '4px 8px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '4px',
        background: 'var(--bg-500, #373245)',
        marginBottom: '8px'
      }}
    >
      <div
        style={{
          color: 'var(--Gray-Scale-500, #948F9E)',
          textAlign: 'center',
          fontFamily: '"Pretendard Variable"',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '16px'
        }}
      >
        {index + 1}
      </div>
    </div>
  );
};
